import React from 'react';
import { observer } from 'mobx-react';
import initials from '../../../../../utils/string';

import { RootStoreContext } from '../../../../../context';

import '../../../../../css/utils/flex.css';
import './FanItem.css';

@observer
class FansList extends React.Component {

  static contextType = RootStoreContext;

  render () {
    const { fan: { user, online } } = this.props;
    const displayName = user.nickname ? user.nickname : user.username;
    return (
      <li
        title={`Start conversation with ${displayName}`}
        className="flex anchor-chat-fan-item items-center"
        onClick={() => this.context.privateMessagingStore.createConversation(user.username)}>
        <div className="anchor-chat-fan-item-avatar flex justify-center items-center">
          {initials(displayName)}
          {online && <div className="online-indicator"></div>}
        </div>
        <p className="fan-list-item-username">{displayName}</p>
      </li>
    );
  }
}

export default FansList;